import { UUID } from "io-ts-types";
import { NextPageContext } from "next";

import { validateAndDecodeParam } from "src/utilities/ssr/validateAndDecodeParam";

function getCustomIDsFromContext(
  ctx: NextPageContext,
  nonprofits?: { primarySlug: string; id: UUID }[]
) {
  let slug: string | undefined;

  if (
    "nonprofitSlugOrUsername" in ctx.query &&
    ctx.query.nonprofitSlugOrUsername
  ) {
    slug = validateAndDecodeParam(ctx, "nonprofitSlugOrUsername").trim();
  } else {
    slug = undefined;
  }

  const nonprofitId = slug
    ? nonprofits?.find((n: { primarySlug: string }) => n.primarySlug === slug)
        ?.id
    : undefined;

  const customIDs = nonprofitId ? { nonprofitId } : undefined;

  return customIDs;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withServerSideTestingProps<
  P extends { [key: string]: any; props?: { [key: string]: any } }
>(handler?: (ctx: NextPageContext) => Promise<P>) {
  return async (ctx: NextPageContext): Promise<P> => {
    const { getServerSideTestingProps } = await import("src/utility/statsig");
    const result = handler ? await handler(ctx) : { props: {} };

    const props = "props" in result && result.props ? result.props : undefined;
    const initialData =
      "props" in result && result.props && "initialData" in result.props
        ? result.props.initialData
        : {};

    const customIDs = getCustomIDsFromContext(ctx, initialData?.nonprofits);
    const testingProps = await getServerSideTestingProps(ctx, customIDs);

    const returnObj = {
      ...(result as any),
      props: {
        ...props,
        initialData: {
          ...initialData,
          ...testingProps,
        },
      },
    };

    return returnObj;
  };
}
